import Vue from 'vue'
import VueAxios from 'vue-axios'

import server from './axios'

Vue.use(VueAxios, server)

export default server;
